import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1.5 10.25C1.5 9.97386 1.72386 9.75 2 9.75H10C10.2761 9.75 10.5 9.97386 10.5 10.25C10.5 10.5261 10.2761 10.75 10 10.75H2C1.72386 10.75 1.5 10.5261 1.5 10.25Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M3 1.25C3.27614 1.25 3.5 1.47386 3.5 1.75V5.25C3.5 6.63071 4.61929 7.75 6 7.75C7.38071 7.75 8.5 6.63071 8.5 5.25V1.75C8.5 1.47386 8.72386 1.25 9 1.25C9.27614 1.25 9.5 1.47386 9.5 1.75V5.25C9.5 7.183 7.933 8.75 6 8.75C4.067 8.75 2.5 7.183 2.5 5.25V1.75C2.5 1.47386 2.72386 1.25 3 1.25Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2 13.667C2 13.2988 2.29848 13.0003 2.66667 13.0003H13.3333C13.7015 13.0003 14 13.2988 14 13.667C14 14.0352 13.7015 14.3337 13.3333 14.3337H2.66667C2.29848 14.3337 2 14.0352 2 13.667Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M4 1.66699C4.36819 1.66699 4.66667 1.96547 4.66667 2.33366V7.00033C4.66667 8.84127 6.15905 10.3337 8 10.3337C9.84095 10.3337 11.3333 8.84128 11.3333 7.00033V2.33366C11.3333 1.96547 11.6318 1.66699 12 1.66699C12.3682 1.66699 12.6667 1.96547 12.6667 2.33366V7.00033C12.6667 9.57765 10.5773 11.667 8 11.667C5.42267 11.667 3.33333 9.57765 3.33333 7.00033V2.33366C3.33333 1.96547 3.63181 1.66699 4 1.66699Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.5 17.083C2.5 16.6228 2.8731 16.2497 3.33333 16.2497H16.6667C17.1269 16.2497 17.5 16.6228 17.5 17.083C17.5 17.5432 17.1269 17.9163 16.6667 17.9163H3.33333C2.8731 17.9163 2.5 17.5432 2.5 17.083Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M5 2.08301C5.46024 2.08301 5.83333 2.4561 5.83333 2.91634V8.74967C5.83333 11.0509 7.69881 12.9163 10 12.9163C12.3012 12.9163 14.1667 11.0509 14.1667 8.74967V2.91634C14.1667 2.4561 14.5398 2.08301 15 2.08301C15.4602 2.08301 15.8333 2.4561 15.8333 2.91634V8.74967C15.8333 11.9713 13.2217 14.583 10 14.583C6.77834 14.583 4.16667 11.9713 4.16667 8.74967V2.91634C4.16667 2.4561 4.53976 2.08301 5 2.08301Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 9.75C10.2761 9.75 10.5 9.97386 10.5 10.25C10.5 10.5261 10.2761 10.75 10 10.75H2C1.72386 10.75 1.5 10.5261 1.5 10.25C1.5 9.97386 1.72386 9.75 2 9.75H10ZM2.5 5.25V1.75C2.5 1.47386 2.72386 1.25 3 1.25C3.27614 1.25 3.5 1.47386 3.5 1.75V5.25C3.5 6.63071 4.61929 7.75 6 7.75C7.38071 7.75 8.5 6.63071 8.5 5.25V1.75C8.5 1.47386 8.72386 1.25 9 1.25C9.27614 1.25 9.5 1.47386 9.5 1.75V5.25C9.5 7.183 7.933 8.75 6 8.75C4.067 8.75 2.5 7.183 2.5 5.25Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3333 13.0003C13.7015 13.0003 14 13.2988 14 13.667C14 14.0352 13.7015 14.3337 13.3333 14.3337H2.66667C2.29848 14.3337 2 14.0352 2 13.667C2 13.2988 2.29848 13.0003 2.66667 13.0003H13.3333ZM3.33333 7.00033V2.33366C3.33333 1.96547 3.63181 1.66699 4 1.66699C4.36819 1.66699 4.66667 1.96547 4.66667 2.33366V7.00033C4.66667 8.84127 6.15905 10.3337 8 10.3337C9.84095 10.3337 11.3333 8.84127 11.3333 7.00033V2.33366C11.3333 1.96547 11.6318 1.66699 12 1.66699C12.3682 1.66699 12.6667 1.96547 12.6667 2.33366V7.00033C12.6667 9.57765 10.5773 11.667 8 11.667C5.42267 11.667 3.33333 9.57765 3.33333 7.00033Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.6667 16.2497C17.1269 16.2497 17.5 16.6228 17.5 17.083C17.5 17.5432 17.1269 17.9163 16.6667 17.9163H3.33333C2.8731 17.9163 2.5 17.5432 2.5 17.083C2.5 16.6228 2.8731 16.2497 3.33333 16.2497H16.6667ZM4.16667 8.74967V2.91634C4.16667 2.4561 4.53976 2.08301 5 2.08301C5.46024 2.08301 5.83333 2.4561 5.83333 2.91634V8.74967C5.83333 11.0509 7.69881 12.9163 10 12.9163C12.3012 12.9163 14.1667 11.0509 14.1667 8.74967V2.91634C14.1667 2.4561 14.5398 2.08301 15 2.08301C15.4602 2.08301 15.8333 2.4561 15.8333 2.91634V8.74967C15.8333 11.9713 13.2217 14.583 10 14.583C6.77834 14.583 4.16667 11.9713 4.16667 8.74967Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconUnderline01: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"underline-01"} {...props} />
);
